import { render, staticRenderFns } from "./BFooter.vue?vue&type=template&id=ee0b3ffa&scoped=true&"
import script from "./BFooter.vue?vue&type=script&lang=js&"
export * from "./BFooter.vue?vue&type=script&lang=js&"
import style0 from "./BFooter.vue?vue&type=style&index=0&id=ee0b3ffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0b3ffa",
  null
  
)

export default component.exports